import axios from 'axios';

const cdnApi = axios.create({
		baseURL: `https://${process.env.VUE_APP_CDN_HOST}`,
	}),
	getFaqList = () => cdnApi.get(`frontend/${environment.region}/v1/commerce-faqs.json`).then((res) => res.data),
	faqAPI = {
		install(Vue) {
			Vue.prototype.$faqAPI = {
				getFaqList,
			};
		},
	};
export default faqAPI;
